module.exports = __webpack_public_path__ + "static/img/关于我们配图-01.f9806a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们配图-01.jpg
// module id = p9pn
// module chunks = 1